module.exports = __webpack_public_path__ + "657d1a6087a0d23becdb27a61d7dd6ff.png";